<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useDashboardNotifications } from '@/composables/useDashboardNotifications'
import DashboardWelcomeNotification from '@/components/dashboard/notifications/DashboardWelcomeNotification.vue'
import DashboardNotificationsEmptyState from '@/components/dashboard/notifications/DashboardNotificationsEmptyState.vue'
import SwiftaidStatusNotification from '@/components/dashboard/notifications/SwiftaidStatusNotification.vue'
import ClaimTaxBackNotification from '@/components/dashboard/notifications/ClaimTaxBackNotification.vue'
import NotificationIndicator from '@/components/dashboard/ui/NotificationIndicator.vue'

const { t } = useI18n()
const { hasVisibleNotifications, actionCount } = useDashboardNotifications()
</script>

<template>
  <section aria-labelledby="dashboard-notifications-heading">
    <div class="sa-section-hd">
      <h2
        id="dashboard-notifications-heading"
        class="sa-section-title sa-section-title--with-indicator"
      >
        {{ $t('Dashboard.Notifications.SectionHeading') }}
        <NotificationIndicator
          v-if="actionCount > 0"
          :count="actionCount"
          :aria-label="
            t('Dashboard.Notifications.SectionCountAria', {
              count: actionCount,
            })
          "
        />
      </h2>
    </div>
    <div v-if="hasVisibleNotifications" class="sa-notifications-stack">
      <DashboardWelcomeNotification />
      <SwiftaidStatusNotification />
      <ClaimTaxBackNotification />
    </div>
    <DashboardNotificationsEmptyState v-else />
  </section>
</template>
